const config = {
  serviceHost: "http://localhost:8080/",
  stripePublicApiKey: "pk_test_T61ffIlMPN7oPaSEbzaf4hsI005bbUZ9pV",
  enableDashboard: true
};

export default config;
